import type { NameSuffix, TitlePrefix } from '@appTypes/esb';

export default (
  optionSelected: string | undefined,
  itemList: NameSuffix[] | TitlePrefix[] = [],
) => {
  const foundItem = itemList.find(item => item.name === optionSelected);

  return foundItem ? Number(foundItem.id) : null;
};
